define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "lodash.debounce", "../../model/domain", "../services/EventManager"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, lodash_debounce_1, domain_1, EventManager_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FWpEoiInfo = void 0;
    lodash_debounce_1 = tslib_1.__importDefault(lodash_debounce_1);
    class FWpEoiInfo extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "WpId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WpIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CostType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CostTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Desc_", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Desc_Error", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CostEstimate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CostEstimateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FWorksProject", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "onChangeBatchFn", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, FWpEoiInfo.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.FWorksProject = parent;
            this.WpId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.FWorksProject = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.WpId = (0, EntityUtil_1.toInt)(entity.WpId);
            a.CostType = (0, EntityUtil_1.toInt)(entity.CostType);
            a.Desc_ = b.Desc_;
            a.CostEstimate = (0, EntityUtil_1.toFloat)(entity.CostEstimate);
            a.AuditCreateDate = b.AuditCreateDate;
            a.AuditCreateUser = b.AuditCreateUser;
            a.AuditEditDate = b.AuditEditDate;
            a.AuditEditUser = b.AuditEditUser;
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
            if (this.FWorksProject) {
                this.onChangeBatchFn = (0, lodash_debounce_1.default)(this.FWorksProject.calculateFees.bind(this.FWorksProject), 250);
                this.addChangeEventAction("CostEstimate", this.onChangeBatchFn.bind(this));
            }
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, FWpEoiInfo.AliasName);
            this.reset();
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqNumber(validationState, "WpId", "Works Project Id");
                this.validateReqNumber(validationState, "CostType", "Cost Type");
                this.validateReqDate(validationState, "AuditCreateDate", "AUDIT_CREATE_DATE");
                this.validateReqString(validationState, "AuditCreateUser", "AUDIT_CREATE_USER");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                WpId: this.WpId,
                CostType: this.CostType,
                Desc_: this.Desc_,
                CostEstimate: this.CostEstimate,
                AuditCreateDate: this.AuditCreateDate,
                AuditCreateUser: this.AuditCreateUser,
                AuditEditDate: this.AuditEditDate,
                AuditEditUser: this.AuditEditUser,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        static create(wp) {
            return new Promise((resolve, reject) => {
                (0, EventManager_1.notify)("Creating new EOI cost line");
                let x = new FWpEoiInfo(null, wp);
                x.CostType = domain_1.FacilityWpEoiInfoTypeDomain.Decommissioning;
                x.CostEstimate = 0;
                wp.FWpEoiInfo.push(x);
                resolve(x);
            });
        }
    }
    exports.FWpEoiInfo = FWpEoiInfo;
    Object.defineProperty(FWpEoiInfo, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "FWpEoiInfo"
    });
    Object.defineProperty(FWpEoiInfo, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Facility Works Project EOI cost estimates"
    });
    Object.defineProperty(FWpEoiInfo, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "WpId", "CostType", "Desc_", "CostEstimate", "AuditCreateDate", "AuditCreateUser", "AuditEditDate", "AuditEditUser"]
    });
    Object.defineProperty(FWpEoiInfo, "WpIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpEoiInfo, "CostTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpEoiInfo, "CostTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpEoiInfo, "Desc_Length", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 500
    });
    Object.defineProperty(FWpEoiInfo, "Desc_Tooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Enter a description for the cost item"
    });
    Object.defineProperty(FWpEoiInfo, "Desc_Req", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWpEoiInfo, "CostEstimateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWpEoiInfo, "AuditCreateDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpEoiInfo, "AuditCreateUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FWpEoiInfo, "AuditCreateUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpEoiInfo, "AuditEditDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWpEoiInfo, "AuditEditUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FWpEoiInfo, "AuditEditUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpEoiInfo.prototype, "WpId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpEoiInfo.prototype, "WpIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpEoiInfo.prototype, "CostType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpEoiInfo.prototype, "CostTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpEoiInfo.prototype, "Desc_", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpEoiInfo.prototype, "Desc_Error", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpEoiInfo.prototype, "CostEstimate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpEoiInfo.prototype, "CostEstimateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpEoiInfo.prototype, "AuditCreateDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpEoiInfo.prototype, "AuditCreateDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpEoiInfo.prototype, "AuditCreateUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpEoiInfo.prototype, "AuditCreateUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpEoiInfo.prototype, "AuditEditDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpEoiInfo.prototype, "AuditEditDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpEoiInfo.prototype, "AuditEditUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpEoiInfo.prototype, "AuditEditUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpEoiInfo.prototype, "FWorksProject", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpEoiInfo.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpEoiInfo.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpEoiInfo.prototype, "merge", null);
});
